<template>
  <div class="ps-page">
    <!-- 面包屑导航 -->
    <div>
        <nav class="breadcrumb-nav">
            <router-link to="/">首页</router-link>
            <span class="separator">/</span>
            <router-link to="/product">产品中心</router-link>
            <span class="separator">/</span>
            <span class="current">穿透式监管</span> 
        </nav>
    </div>

    <!-- 英雄区（产品Banner） -->
    <section class="ps-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>穿透式监管 · 全链条风险穿透与责任追溯平台<br><span style="color: var(--ps-accent-blue);">股权穿透 · 资金穿透 · 交易穿透 · 责任穿透</span></h1>
        <p class="ps-subhead">通过数据整合与智能图谱建模，实现对股权结构、资金流向、关联交易与责任主体的全链条穿透监管，构建"数据驱动+图谱建模+风险预测+责任追溯"的数字监管新模式。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="ps-btn ps-btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="ps-btn ps-btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="ps-keyword-cloud">
        <h2 class="ps-keyword-tag highlight">穿透式监管</h2>
        <h2 class="ps-keyword-tag">股权穿透</h2>
        <h2 class="ps-keyword-tag">资金穿透</h2>
        <h2 class="ps-keyword-tag">关联交易</h2>
        <h2 class="ps-keyword-tag">实际控制人识别</h2>
        <h2 class="ps-keyword-tag">监管科技</h2>
        <h2 class="ps-keyword-tag">RegTech</h2>
        <h2 class="ps-keyword-tag">风险穿透</h2>
        <h2 class="ps-keyword-tag">责任追溯</h2>
        <h2 class="ps-keyword-tag">围标串标</h2>
      </div>
    </section>

    <!-- 背景与痛点 -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 当前监管核心痛点</h2>
      <div class="ps-card-grid-3">
        <div class="ps-feature-card">
          <h3>股权结构复杂，难识别最终控制人</h3>
          <p>多层嵌套持股、交叉控股、隐性一致行动人，传统手段难以穿透至最终实际控制人。</p>
        </div>
        <div class="ps-feature-card">
          <h3>资金流向隐蔽，难追溯真实用途</h3>
          <p>多账户循环转账、资金空转、异常资金回流，资金路径追踪困难。</p>
        </div>
        <div class="ps-feature-card">
          <h3>关联交易隐蔽化</h3>
          <p>利益输送、围标串标、空壳企业参与交易，隐性关联关系难以识别。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 16px;">2026年监管环境强调穿透式监管、审计全覆盖、科技强审，传统报表式监管已无法满足"信息滞后、结构不透明、责任模糊"等挑战。古杉数据深耕数字化监管领域多年，深刻洞察央企国企、金融机构及政府监管机构在穿透式监管方面的核心诉求与实践难点。</p>
      <p style="margin-top: 16px; font-size: 16px;">我们围绕监管数字化需求，提供从<router-link to="/consulting" style="color: var(--ps-accent-blue); font-weight: 600;">数字化转型咨询规划</router-link>到<router-link to="/product" style="color: var(--ps-accent-blue); font-weight: 600;">智能监管产品交付</router-link>的一站式服务，帮助客户快速构建穿透式监管能力。</p>
    </section>

    <!-- 产品定位 -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 产品定位</h2>
      <div class="ps-arch-card" style="background: #F5F5F5; color: white;">
        <h3 style="color: black; margin-bottom: 20px;">全链条穿透式监管平台</h3>
        <p style="font-size: 16px;">（1）集数据整合、关系图谱建模、风险识别、责任追溯、AI智能分析于一体的数字化监管解决方案，实现"穿透结构、穿透资金、穿透业务、穿透责任"。</p>
        <p style="font-size: 16px;">（2）区别于传统报表式合规检查，穿透式监管平台以图数据库与知识图谱为底层技术基座，通过多源异构数据融合、智能关系推理与动态风险建模，将监管模式从"事后审查"升级为"事前预警+事中穿透+事后追溯"的全生命周期数字化监管体系。</p>
      </div>
    </section>

    <!-- 核心功能模块（五个卡片，带颜色标识）五大核心穿透能力 -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 五大核心穿透能力</h2>
      <p style="font-size: 16px; max-width: 900px; margin-bottom: 16px;">平台围绕"股权穿透、资金穿透、交易穿透、责任穿透、AI智能穿透"五大维度构建完整的穿透式监管能力矩阵，从数据接入到风险识别、从关系发现到责任追溯，全流程智能化驱动，覆盖监管机构日常监督的核心场景。</p>
      <div class="ps-card-grid-5">
        <!-- 模块1：股权与实际控制人穿透分析 -->
        <div class="ps-feature-card">
          <h3>股权与实际控制人穿透</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 多层股权路径展开</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 最终控制人识别</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 交叉持股/一致行动人</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 企业关系图谱可视化</li>
          </ul>
          <div style="margin-top: 16px;"><span class="ps-keyword-tag">股权穿透</span><span class="ps-keyword-tag">实际控制人</span></div>
        </div>

        <!-- 模块2：资金流向穿透监控 -->
        <div class="ps-feature-card">
          <h3>资金流向穿透监控</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 资金全路径追踪</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 异常资金循环识别</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 高频交易检测</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 资金回流风险预警</li>
          </ul>
          <div style="margin-top: 16px;"><span class="ps-keyword-tag">资金穿透</span><span class="ps-keyword-tag">反舞弊</span></div>
        </div>

        <!-- 模块3：关联交易与业务穿透分析 -->
        <div class="ps-feature-card">
          <h3>关联交易与业务穿透</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 合同自动解析与条款识别</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 交易金额异常检测</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 供应商关联关系识别</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 围标串标智能分析</li>
          </ul>
          <div style="margin-top: 16px;"><span class="ps-keyword-tag">关联交易</span><span class="ps-keyword-tag">围标串标</span></div>
        </div>

        <!-- 模块4：风险责任穿透与问责模型 -->
        <div class="ps-feature-card">
          <h3>风险责任穿透与问责</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 风险事件自动映射岗位</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 干部履职风险画像</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 风险责任趋势分析</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 风险评分与排名</li>
          </ul>
          <div style="margin-top: 16px;"><span class="ps-keyword-tag">责任追溯</span><span class="ps-keyword-tag">干部画像</span></div>
        </div>

        <!-- 模块5：AI智能穿透分析引擎 -->
        <div class="ps-feature-card">
          <h3>AI智能穿透分析引擎</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 自动解读复杂交易结构</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 自动生成风险报告</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 自动推送监管提示</li>
            <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 自然语言查询问答</li>
          </ul>
          <div style="margin-top: 16px;"><span class="ps-keyword-tag">AI监管</span><span class="ps-keyword-tag">大模型</span></div>
        </div>
      </div>
    </section>

    <!-- 技术架构亮点 -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 技术架构亮点</h2>
      <p style="font-size: 16px; max-width: 900px; margin-bottom: 16px;">平台采用图数据库引擎与微服务架构，底层融合大语言模型、风险预测算法与实时流计算技术，确保穿透分析的高效性、准确性与安全合规性，支持私有化部署与混合云架构。</p>
      <div class="ps-arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="ps-compliance-badge">企业级数据中台</span>
          <span class="ps-compliance-badge">图数据库引擎</span>
          <span class="ps-compliance-badge">风险预测算法</span>
          <span class="ps-compliance-badge">大语言模型</span>
          <span class="ps-compliance-badge">实时预警驾驶舱</span>
          <span class="ps-compliance-badge">图谱可视化</span>
        </div>
        <div class="ps-arch-grid">
          <div class="ps-arch-item">
            <h4>图数据库与关系图谱</h4>
            <p>基于图数据库构建企业关系网络，支持股权、资金、交易的多层路径计算与可视化展示。</p>
          </div>
          <div class="ps-arch-item">
            <h4>AI大模型语义分析</h4>
            <p>自动解读合同条款、交易结构，支持自然语言交互，降低使用门槛。</p>
          </div>
          <div class="ps-arch-item">
            <h4>实时预警驾驶舱</h4>
            <p>动态监测风险指标，异常情况自动推送，支持一屏掌控全局风险。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型应用场景 -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 典型应用场景</h2>
      <div class="ps-card-grid-4">
        <div class="ps-feature-card">
          <h3>国资监管与投资监管</h3>
          <p>股权穿透分析、投资结构合规检查，防止国有资产流失。</p>
        </div>
        <div class="ps-feature-card">
          <h3>金融与资金监管</h3>
          <p>资金路径追踪、异常交易识别，防范金融风险。</p>
        </div>
        <div class="ps-feature-card">
          <h3>招投标与供应链监管</h3>
          <p>围标串标识别、供应商关联排查，保障采购公平。</p>
        </div>
        <div class="ps-feature-card">
          <h3>干部履职监督与问责</h3>
          <p>经责审计支撑、风险责任追溯，提升监督权威性。</p>
        </div>
      </div>
      <p style="margin-top: 24px; text-align: center; font-size: 16px;">查看<router-link to="/case" style="color: var(--ps-accent-blue); font-weight: 600;">客户成功案例</router-link>，了解穿透式监管平台在各行业的实际落地成效。</p>
    </section>

    <!-- 产品核心优势 -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 产品核心优势</h2>
      <div class="ps-card-grid-4">
        <div class="ps-feature-card">
          <h3>全链条穿透能力</h3>
          <p>覆盖股权、资金、交易、责任四大维度，穿透至最终控制人与责任人。</p>
        </div>
        <div class="ps-feature-card">
          <h3>风险前置预警</h3>
          <p>从事后发现转向事前预警，提前识别风险隐患。</p>
        </div>
        <div class="ps-feature-card">
          <h3>数据驱动精准监管</h3>
          <p>降低人工经验依赖，提高识别精度与监管效率。</p>
        </div>
        <div class="ps-feature-card">
          <h3>支撑国家穿透式监管</h3>
          <p>构建数字化、智能化、全覆盖监管体系，满足政策要求。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 关键成果与价值</h2>
      <div class="ps-stat-grid">
        <div class="ps-stat-card">
          <div class="ps-stat-number">80%</div>
          <p>股权穿透效率提升</p>
        </div>
        <div class="ps-stat-card">
          <div class="ps-stat-number">60%</div>
          <p>异常资金识别率提升</p>
        </div>
        <div class="ps-stat-card">
          <div class="ps-stat-number">实时</div>
          <p>关联交易监控</p>
        </div>
        <div class="ps-stat-card">
          <div class="ps-stat-number">100%</div>
          <p>责任主体可追溯</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 穿透多层股权至最终实际控制人</li>
          <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 资金路径全链路可视化追踪</li>
          <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 隐性关联交易自动识别</li>
          <li class="ps-list-item"><i class="fa-regular fa-circle-check"></i> 风险责任精准定位至具体岗位</li>
        </ul>
      </div>
      <p style="margin-top: 24px; text-align: center; font-size: 16px;">探索更多<router-link to="/industry" style="color: var(--ps-accent-blue); font-weight: 600;">行业解决方案</router-link>，发现穿透式监管在您所在行业的数字化转型应用潜力。</p>
    </section>

    <!-- 适用客户群体 -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 适用客户群体</h2>
      <p style="margin-bottom: 16px; font-size: 16px;">穿透式监管平台服务于各类需要实现深度监管穿透的组织机构，无论是国资监管、金融监管还是企业内部审计监督。我们还提供<router-link to="/training" style="color: var(--ps-accent-blue); font-weight: 600;">专业培训课程</router-link>，帮助监管人员快速掌握平台操作与穿透分析方法论。</p>
      <div class="ps-client-tags">
        <span class="ps-client-tag">国资委/国资监管机构</span>
        <span class="ps-client-tag">中央企业集团</span>
        <span class="ps-client-tag">地方国企</span>
        <span class="ps-client-tag">金融监管机构</span>
        <span class="ps-client-tag">银行/保险/证券</span>
        <span class="ps-client-tag">大型投资集团</span>
        <span class="ps-client-tag">审计机关</span>
        <span class="ps-client-tag">纪检监察部门</span>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="ps-container">
      <h2><i class="fa-regular fa-star"></i> 常见问题</h2>
      <div class="ps-faq-list">
        <div class="ps-faq-item">
          <div class="ps-faq-question"><i class="fa-regular fa-message"></i> 穿透式监管需要哪些数据源？</div>
          <div class="ps-faq-answer">需要工商登记数据、股权结构信息、银行流水、合同文本、招投标记录、内部ERP数据等。平台支持多源数据整合与清洗。</div>
        </div>
        <div class="ps-faq-item">
          <div class="ps-faq-question"><i class="fa-regular fa-message"></i> 如何保证股权穿透的准确性？</div>
          <div class="ps-faq-answer">系统基于图数据库与股权计算引擎，结合工商变更记录、一致行动人协议等，通过算法模型计算实际控制权比例，结果可追溯验证。</div>
        </div>
        <div class="ps-faq-item">
          <div class="ps-faq-question"><i class="fa-regular fa-message"></i> 是否支持实时资金监控？</div>
          <div class="ps-faq-answer">支持与银行系统、财务系统对接，实现准实时资金流水监控，异常交易触发预警。</div>
        </div>
        <div class="ps-faq-item">
          <div class="ps-faq-question"><i class="fa-regular fa-message"></i> 责任穿透如何与干部评价关联？</div>
          <div class="ps-faq-answer">平台将风险事件与岗位职责、干部履职数据关联，自动生成干部风险画像，支撑经责审计与问责。</div>
        </div>
        <div class="ps-faq-item">
          <div class="ps-faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="ps-faq-answer">一般3-4个月完成试点上线，包括数据接入、图谱构建、模型配置和人员培训。</div>
        </div>
      </div>
    </section>

    <!-- 预约咨询 -->
    <section id="contact" class="section cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建可信、统一的数据治理与 AI 治理体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>咨询方向</label>
            <select>
              <option value="">-- 请选择咨询方向 --</option>
              <option>穿透式监管平台咨询</option>
              <option>股权穿透 / 实际控制人识别</option>
              <option>资金穿透 / 资金流向追踪</option>
              <option>关联交易 / 围标串标识别</option>
              <option>AI 智能穿透 / 风险预警</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「穿透监管」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'ProductDetailPenetratingSupervision',
  data() {
    return {
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    },
    submitForm() {
      alert('表单已提交');
      this.showModal = false;
    },
    showQrCode() {
      this.showQrModal = true;
    }
  }
};
</script>

<style scoped>
.ps-page {
  --ps-primary-dark: #1D4E4E;
  --ps-primary-soft: #e9f3f2;
  --ps-accent-gold: #D4AF37;
  --ps-accent-blue: #2A7DE1;
  --ps-gray-light: #f8fafc;
  --ps-gray-border: #e2e8f0;
  --ps-text-dark: #0f2a2a;
  --ps-text-regular: #2d3f4b;
  --ps-white: #ffffff;
  --ps-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--sar-text-regular);
  font-size: 16px;
  line-height: 1.8;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

.ps-page *, .ps-page *::before, .ps-page *::after {
  box-sizing: border-box;
}

.ps-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width:100%
}

.ps-page section {
  padding: 40px 12px;
}

.ps-page h1, .ps-page h2, .ps-page h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--ps-text-dark);
}

.ps-page h1 {
  font-size: 42px;
  line-height: 1.2;
}

.ps-page h2 {
  font-size: 28px;
  margin-bottom: 24px;
}

.ps-page h2 i {
  color: var(--ps-accent-blue);
  margin-right: 8px;
}

.ps-page h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.ps-subhead {
  font-size: 18px;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.ps-btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.ps-btn-primary {
  background-color: var(--ps-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.ps-btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}


.ps-btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--ps-primary-dark);
  color: var(--ps-primary-dark);
}

.ps-btn-outline:hover {
  background-color: var(--ps-primary-dark);
  color: white;
}

.ps-btn-accent {
  background-color: var(--ps-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.ps-btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 导航 */
.ps-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid var(--ps-gray-border);
  background-color: white;
  margin-bottom: 20px;
}

.ps-logo {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--ps-primary-dark);
}

.ps-logo span {
  color: var(--ps-accent-gold);
}

.ps-back-link {
  text-decoration: none;
  color: var(--ps-primary-dark);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--ps-gray-border);
  padding: 8px 16px;
  border-radius: 40px;
  transition: 0.2s;
}

.ps-back-link:hover {
  background-color: var(--ps-primary-soft);
  border-color: var(--ps-primary-dark);
}

/* 关键词标签云 */
.ps-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.ps-keyword-tag {
  background: var(--ps-primary-soft);
  color: var(--ps-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.ps-keyword-tag.highlight {
  background: var(--ps-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.ps-card-grid-3, .ps-card-grid-4, .ps-card-grid-5 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.ps-card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.ps-card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.ps-card-grid-5 {
  grid-template-columns: repeat(5, 1fr);
}

.ps-feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--ps-shadow);
  border: 1px solid var(--ps-gray-border);
  transition: transform 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ps-feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.ps-card-icon {
  font-size: 2.5rem;
  color: var(--ps-primary-dark);
  margin-bottom: 20px;
}

.ps-list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.ps-list-item i {
  color: var(--ps-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.ps-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.ps-stat-card {
  background: var(--ps-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.ps-stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--ps-primary-dark);
  margin-bottom: 8px;
}

.ps-client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.ps-client-tag {
  background: white;
  border: 1px solid var(--ps-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--ps-text-dark);
}

.ps-case-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: var(--ps-shadow);
}

.ps-case-stats {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--ps-primary-dark);
  margin: 16px 0 8px;
}

/* 技术架构卡片 */
.ps-arch-card {
  background: var(--ps-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.ps-arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.ps-arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.ps-compliance-badge {
  display: inline-block;
  background: var(--ps-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.ps-faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.ps-faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--ps-gray-border);
}

.ps-faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--ps-text-dark);
}

.ps-faq-question i {
  color: var(--ps-accent-gold);
}

.ps-faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.ps-cta-block {
  background: var(--ps-primary-dark);
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.ps-cta-block h2 {
  color: white;
}

.ps-cta-block .ps-btn-primary {
  background-color: white;
  color: var(--ps-primary-dark);
  margin: 0 8px;
}

.ps-cta-block .ps-btn-outline {
  border-color: white;
  color: white;
}

.ps-cta-block .ps-btn-outline:hover {
  background-color: white;
  color: var(--ps-primary-dark);
}



.sar-cta-block {
  background: #f8fafc;
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.sar-cta-block .sar-h2 {
  color: #1D4E4E;
}

.sar-cta-block .sar-btn-primary {
  background-color: white;
  color: #1D4E4E;
  margin: 0 8px;
}

.sar-cta-block .sar-btn-outline {
  border-color: white;
  color: white;
}

.sar-cta-block .sar-btn-outline:hover {
  background-color: white;
  color: #1D4E4E;
}


/* 模态框 */
.ps-modal {
  display: flex;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.ps-modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.ps-close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.ps-modal h3 {
  margin-bottom: 24px;
}

.ps-form-group {
  margin-bottom: 20px;
}

.ps-form-group input, .ps-form-group textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--ps-gray-border);
  border-radius: 30px;
  font-size: 1rem;
}

.ps-modal .ps-btn {
  width: 100%;
  margin-top: 10px;
}

.ps-footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--ps-gray-border);
  margin-top: 40px;
}



/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}

.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--gov-accent-blue);
  font-weight: 600;
}



/* 底部转化 */

.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}


.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  flex-wrap: wrap;
}

.qr-code {
  display: inline-block;
  background: white;
  padding: 12px 24px;
  border-radius: 60px;
  margin-top: 20px;
  cursor: pointer;
  color: var(--deep-indigo);
}

.btn-primary {
  display: inline-block;
  background: #1F3F8F;
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(31,63,143,0.3);
}

.btn-outline-light {
  background: #EAF0FB;
  color: black;
  border: 1px solid #0e3170;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  text-decoration: none;
}
.btn-outline-light:hover {
  background: rgba(255,255,255,0.1);
  border-color: #0e3170;
}

/* 响应式 */
@media (max-width: 1100px) {
  .ps-card-grid-5 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 900px) {
  .ps-card-grid-4, .ps-card-grid-5, .ps-stat-grid, .ps-arch-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .ps-card-grid-3 {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 700px) {
  .ps-card-grid-4, .ps-card-grid-5, .ps-stat-grid, .ps-arch-grid {
    grid-template-columns: 1fr;
  }
  .ps-page h1 { font-size: 32px; }
  .ps-navbar { flex-direction: column; gap: 16px; }
}

/* ============ 预约咨询区段 ============ */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}
</style>
